export default {
  banner: {
    title: "金融行业解决方案",
    subtitle:
      "深耕银行、证券、基金、资管等企业，实现 Gartner Identity Fabric 理念的身份安全治理能力，构建金融行业自主可控的身份认证管理体系。",
  },
  marquee: {
    item1: {
      title1: "某「世界 500 强」银行",
      desc1:
        "国家从体制外推动银行业改革的第一家试点银行；在”数字化转型“中，一直处于行业领先地位。",
      title2: "原有 IAM 系统全面安全加固",
      desc2:
        "Authing 与我们携手，在原有的身份体系基础上坚实风控能力，使我们先一步杜绝风险，为客户提供更安全的服务。此外，Authing 的 API/SDK 也让我们感到惊喜，嵌入集成的速度非常快。",
    },
    item2: {
      title1: "某知名一站式投资平台",
      desc1: "全国首家免费的港美 A 股 LV2 高级行情、数据分析的互联网券商平台。",
      title2: "可编排的身份数据集成与分发能力",
      desc2:
        "Authing 云中立、开发者友好的特性，能让我们更便捷的接入各类本土应用及海外软件，并保证数据信息的安全可控。",
    },
    item3: {
      title1: "某领先的保险服务商",
      desc1:
        "在全球著名咨询企业贝恩公司发表的 NPS 中，荣列“消费者推荐财产保险公司”第一位。",
      title2: "灵活可扩展的混合云认证体系",
      desc2:
        "Authing 的产品后台操作体验达到了实打实的开箱即用，并且响应速度非常快，帮助我们用很少的精力搭建起复杂的身份系统",
    },
    item4: {
      title1: "某 TOP 基金服务商",
      desc1: "一家深度运用互联网技术、深度耕耘泛资管行业的创新型金融科技公司。",
      title2: "可嵌入的下一代统一身份管理",
      desc2:
        "在企业的高速发展下，Authing 基于云原生的弹性伸缩能力及低代码拓展能力，让我们实现更加安全、细粒度的身份管理，提供用户更优质的服务体验。",
    },
  },
  question: {
    title: "监管日趋严格，转型「智慧金融」迫在眉睫",
    cardOne: {
      title: "数据割裂，统一管理难落地",

      descli1:
        "应用多：使用不同业务系统时，需进行多次认证，账号统一困难、操作效率低。",
      descli2:
        "人员多：员工入转调离频繁，并涉及大量编外人员，运维效率差，且可能有漏关权限的风险。",
    },
    cardTwo: {
      title: "权限混乱，加重防范挑战",
      descli1:
        "各业务系统权限管理分散、多套并行、缺乏统一的策略，安全性与效率低下。",
      descli2:
        "权限管理的业务逻辑复杂，金融行业尤其细致，自研系统需投入大量开发成本，ROI 低。",
    },
    cardThree: {
      title: "国产化趋势，推进超预期",
      descli1:
        "据分析，信创基础软硬件在 IT 外采中占比要求将进一步提高至 15-25%；金融 IT 有望在 2025 年实现全面国产化。",
      descli2: "信息化创新自主可控的趋势下，需满足国产化系统替换 AD 的新趋势。",
    },
    cardFour: {
      title: "监管缩紧，合规审计难满足",
      descli1:
        "证券基金：当完善用户认证、访问控制、数据加密、日志记录、非法入侵检测等保护措施。 ——《中国证券监督管理委员会令第 152 号》",
      descli2:
        "保险：应建立完善的信息技术基础设施和安全保障体系；采取边界防护入侵检测、数据保护等技术手段，加强信息系统和业务数据的安全管理。 ——《互联网保险业务监督办法》",
      descli3:
        " 银行与消费金融：应建立健全适应互联网贷款的业务特点的风险治理架构、风险管理政策和程序、内部控制和审计体系。 ——《商业银行互联网贷款管理暂行办法》",
    },
  },
  chart: {
    title: "基于身份，加快“金融行业数字化”落地",
    img: "https://files.authing.co/authing-website/finance-frame-zh.png",
  },
  advantage: {
    item1: {
      title: "建立统一身份认证与管理，提高运维效率",
      desc:
        "通过 Authing 预集成 2000+ 应用及自研应用，能帮助企业高效实现单点登录，建立统一身份认证，并进一步实现多个系统帐号「一处管理、处处同步」，有效避免手动运维带来的安全风险与低效。",
      alt: "",
    },
    item2: {
      title: "打造细粒度权限管理，保护信息安全",
      desc:
        "Authing 提供 RBAC、ABAC、NGAC 等权限管理模型，帮助企业针对不同场景，建立合适的权限控制策略。开发人员仅需接入 API/SDK，即可高效实现权限管理；还能通过 Pipeline 和 Webhook 等扩展能力，动态调整员工访问权限。",
      alt: "",
    },
    item3: {
      title: "增强 AD 身份体系，满足「国产信创」需求",
      desc:
        "政策加快“国产信创”趋势，Authing 通过“增强微软 AD 身份方案”，能有效补足 AD 身份管理学习成本高、无法对接云应用等问题；或帮助企业进行无痛迁移，建立自主可控的基础软件体系。",
      alt: "",
    },
    item4: {
      title: "构建智能金融风控中台，实现安全合规",
      desc:
        "基于身份底座，以“零信任”为架构，达到「事前设置策略预防风险」、「事中实时监控动态降权」、「事后追溯分析优化策略」的效果，多维度提升安全能力；并通过全局、统一的审计日志管理，满足监管需求。",
      alt: "",
    },
  },
  productivity: {
    title: "选择高安全、高性能、高生产力的身份产品",
    item1: {
      title: "高安全",
      desc1:
        "数据存储使用 AES-256 算法加密；通过 SSL/TLS 协议加密传输；使用 KMS 管理密钥，密钥定期轮换。",
      desc2: "7x24 小时的安全应急响应；两地三中心备份，保证灾难时快速恢复。",
      desc3: "ISO、等保三级、数据保护条例等多项认证。",
    },
    item2: {
      title: "高性能",
      desc1:
        " 云原生：采用 Kubernetes 容器化技术，支持分钟级别弹性扩容，最大可支持亿级别用户认证访问场景。",
      desc2: "云中立：最大程度兼容用户的云环境，不被原有的云厂商捆绑。",
    },
    item3: {
      title: "高生产力",
      desc1: " 开发者友好：提供丰富登录、认证、授权 API/SDK，降低研发成本。",
      desc2: "快速集成 2000+ 主流应用，简单、高效的建立身份中台。",
    },
  },
};
